import { CplEventAction } from "../utils";

export enum GaEventCategories {
  CPL = "CPL",
  SWEEPSTAKES = "Sweepstakes",
}

export interface GaEvent {
  category: GaEventCategories;
  action: CplEventAction | GaSweepstakesEventActions;
  label?: string;
  value?: number;
  nonInteraction?: boolean;
}

export enum GaSweepstakesEventActions {
  ENTER_FLOW = "Enter Flow",
  PLAY_QUIZ = "Play Quiz",
  COMPLETE_QUIZ = "Complete Quiz",
}
